<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="refreshTable"
    >
      <template #table>
        <b-table
          ref="ref-email-events-table"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :fields="fields"
          :items="myProvider"
          primary-key="id"
          :empty-text="$t('NO MATCHING RECORDS FOUND')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(title)="data">
            <span class="font-strong text-left">
              <p v-highlight="data.value">{{ data.value }}</p>
            </span>
          </template>

          <template #cell(subject)="data">
            <span class="font-strong text-left">
              <p v-highlight="data.value">{{ data.value }}</p>
            </span>
          </template>

          <template #cell(description)="data">
            <TextWrapper v-if="data.value" :text="data.value" :maxLength="50" />
          </template>

          <template #cell(status)="data">
            <b-form-checkbox
              v-model="data.value"
              :switch="true"
              :size="'sm'"
              :variant="'primary'"
              :value="'active'"
              :unchecked-value="'inactive'"
              @input="changeStatus(data.item, data.value)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>
  </div>
</template>
<script>
import EmailEventService from "@/views/settings/views/general/components/email/services/email.events.service.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/settings/views/general/components/email/fields/email.event.fields.js";
import TextWrapper from "@/views/commons/utilities/TextWrapper.vue";

export default {
  name : "EmailEvents",
  components: {
    FilterSlot,
    TextWrapper,
  },
  directives: {
    highlight: {
      inserted: function (el, binding) {
        const text = el.innerText;
        const words = text.split(" ");
        const highlightedText = words
          .map((word) => {
            if (word.includes("@")) {
              return `<span class="text-primary">${word}</span>`;
            }
            return word;
          })
          .join(" ");

        el.innerHTML = highlightedText;
      },
    },
  },
  data() {
    return {
      fields: Fields,
      filters: [],
      isBusy: false,
      searchQuery: "",
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
    };
  },
  methods: {
    async myProvider(ctx) {
      try {
        this.addPreloader();
        let params = {};
        const { data } = await EmailEventService.listEmailEvents(params);
        return data.data || [];
      } catch (error) {
        console.log(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async changeStatus(data, value) {
      try {
        this.addPreloader();
        let params = {
          id: data.id,
          status: value,
        };
        console.log(params);
        await EmailEventService.enableOrDisableEmailEvent(params);
      } catch (error) {
        console.log(error);
      } finally {
        await this.removePreloader();
      }
    },
    refreshTable() {
      this.$refs["ref-email-events-table"].refresh();
    },
  },
};
</script>